export default __webpack_public_path__ + "static/media/benifit-one-icon.6cea0b9e.svg";